<template>
  
  <div class="hello" v-loading="loading"  fullscreen lock element-loading-text="数据提交中..." element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.8)">

      <Header></Header>

      <el-row>
        <el-col >
          <div class="grid-content bg-purple">{{msg}}</div>
        </el-col>
      </el-row>

      <Bottom></Bottom>
   </div>
</template>

<script>
import Header from "@/components/public/Header.vue"
import Bottom from "@/components/public/Bottom.vue"
export default {
  name: 'MainFrame',
  data () {
    return {
      loading: false,
      name:'MainFrame',
      dialogVisible: false,
      msg: '1. 参评企业为独立法人，注册地位于中国；2. 参评企业创立时间在2年以上10年以内；3. 参评企业未入选过“未来之星”；4. 参评企业未公开上市或上市不满一周年（至2022年5月1日，上市未满一年）；5. 参评企业具有创新性及高成长性，以下指标中至少满足两项：• 估值或市值在50亿人民币以上；• 融资轮次达到B轮及以上；• 近三年营收或用户等核心指标年均增长率不低于10%；• 市场占有率或核心指标居行业前三名；',
      input:'asas',
      data:
      [
        {
          rename:'公司概况',
          section:'A',
          data:[
            {question:'公司简称',type:'input',section:'A1',tname:'sample_name'},
            {question:'公司全称',type:'input',section:'A2',tname:'company'},
            {question:'所属领域',type:'select',section:'A3',tname:'industry',option:[
              {option_name:'新消费', vals:'autodriver1'},
              {option_name:'生物医药', vals:'autodriver2'},
              {option_name:'物流', vals:'autodriver3'},
              {option_name:'先进制造', vals:'autodriver4'},
              {option_name:'自动驾驶', vals:'autodriver5'},
              {option_name:'人工智能', vals:'autodriver6'},
              {option_name:'IT', vals:'autodriver7'},
              {option_name:'芯片', vals:'autodriver8'},
              {option_name:'新能源', vals:'autodriver9'},
              {option_name:'大数据/云', vals:'autodriver10'},
              {option_name:'农业', vals:'autodriver11'},
              {option_name:'其他（请注明）', vals:'autodriver12'},
            ]},
            {question:'公司主营产品（服务）是否已经进入市场',tname:'is_of',type:'radio',section:'A4',option:[
              {option_name:'是',vals:'yes'},
              {option_name:'否',vals:'no'},
            ]},
            {question:'最新员工数',type:'input',section:'A2',tname:'number'},
            {question:'公司总部所在地',type:'text',section:'A2',tname:'address',max:'50'},

          ]
        },

        {
         rename:'财务&融资',
         section:'B',
          data:[

            {question:'营收年均增长率（近三年）',type:'input',section:'A1',tname:'increas'},
            {question:'目前估值',type:'input',section:'A1',tname:'vaulation'},
            {question:'最新一轮融资时间、轮次、金额（示例：2021年5月C轮1亿元人民币）',type:'text',section:'A2',tname:'newinfo'},
            {question:'创立以来的融资总额（单位：元）',type:'input',section:'A2',tname:'total'},
            {question:'主要投资方（列举3个即可）',type:'text',section:'A2',tname:'preinvent'},


          ]},

           {
         rename:'运营&发展',
         section:'C',
          data:[
            {question:'截至目前，公司的主要用户/客户群体',type:'input',section:'A1',tname:'user_type'}
          ]},


        
      

      ],
      form:{
        sample_name:'',
        company:'',
        industry:'',
        is_of:'',
        number:'',
        address:'',
        increas:'',
        vaulation:'',
        newinfo:'',
        total:'',
        preinvent:'',
        user_type:''

      },
        rules:{
            rename:[
              {required:true, message:'请输入公司名称'},
              {min:3,max:20, message:'输入长度在3-20个字符',trigger:'blur'}
            ]
        }
          
        
    }
  },
   methods: {

    selectBlur(even) {
      console.log(even.target.value)
      if (even.target.value) {
        this.form.industry = even.target.value;
      }
    },
     
    currStationChange(val) {
          console.log('currStationChange', val)
          if (val == 'autodriver12') {

            this.queryUnit(val)
          } 
    },

    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {


            var config = {
              method: 'post',
              url: '/api/futurestar2022',
              headers: { 
                  'Content-Type': 'application/json'
              },
              data : JSON.parse(JSON.stringify(this.form))
            };
            

              this.$axios(config).then(res=>{
                console.log('请求成功')

                 this.$message({
                  message: '信息提交成功！',
                  type: 'success'
                });

              }).catch(error=>{
                console.log('请求失败')
              })
            // alert('submit!');


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {

        this.$refs[formName].resetFields();
      }
    },
  components:{
    Header,
    Bottom
  }
}
</script>

<style>
.el-message ,
.el-message--success{
    top: 28px !important
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-form-item__label{
  /* float: left; */
}
.header_them{
  text-align: center;
  font-weight: bold;
  color:#9a3b18;
  font-size:18px;
}
.item h3{color:#e85a50;}
.icon_s{
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #ec8923;
  text-align: center;
  line-height: 20px;
  border-radius: 20px;
  margin-right:10px;
  font-size: 10px;
  /* color:#fa5c00; */
  color:white;

}
  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
    background: #f7f7f7;
  }
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #f7f7f7;
  }
  .bg-purple {
    background: #f7f7f7;
    width:100%;
  }
  .bg-purple-light {
    background: #f7f7f7;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    padding: 30px 5%;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #efeee8;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainFrame.vue